import 'flag-icons/css/flag-icons.css';
import './termin-teaser.scss';

class InfoOverlay {
    constructor ($element) {
        this.$infoOverlay = $element;
        this.$infoOverlayToggle = this.$infoOverlay.querySelectorAll('[data-info-overlay="areaToggle"]');
        this.initialize();
    }

    initialize () {
        this.changeA11yLabelsByToggle();
    }

    // Set Aria Labels for InfoOverlay by Toggle / On click
    changeA11yLabelsByToggle () {
        if (this.$infoOverlayToggle.length > 0) {
            this.$infoOverlayToggle.forEach($areaToggle => {
                let activeContent = JSON.parse($areaToggle.dataset.infoOverlayActive);
                const $areaContent = this.$infoOverlay.querySelector(`[data-info-overlay-area="${$areaToggle.dataset.infoOverlayId}"]`);

                const setAreaState = () => {
                    if (activeContent) {
                        $areaToggle.setAttribute('aria-pressed', 'true');
                        $areaContent.setAttribute('aria-hidden', 'false');
                    } else {
                        $areaToggle.setAttribute('aria-pressed', 'false');
                        $areaContent.setAttribute('aria-hidden', 'true');
                    }
                };

                // Init call - set Aria Labels by Aria State
                setAreaState();

                $areaToggle.onclick = (e) => {
                    e.preventDefault();
                    activeContent = !activeContent;
                    $areaToggle.dataset.infoOverlayActive = activeContent;
                    setAreaState();
                };
            });
        }
    }
}

export { InfoOverlay };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$infoOverlay = $context.querySelectorAll('[data-info-overlay="root"]');
        for (let i = 0; i < $$infoOverlay.length; i++) {
            const $infoOverlay = $$infoOverlay[i];

            $infoOverlay.API = new InfoOverlay($infoOverlay);
        }
    }
});
